import { gsap} from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const init = () => {
  const parallaxElms = document.querySelectorAll('.js-overviewParallax');
  if (!parallaxElms.length) return;

  parallaxElms.forEach((elm) => {
    const img = elm.querySelector('picture');
    let percent = 20;
    gsap.fromTo(
      img,
      {
        yPercent: -percent / 2,
      },
      {
        yPercent: percent / 2,
        ease: "none",
        scrollTrigger: {
          name: "parallax",
          trigger: img,
          start: "top bottom",
          end: "bottom top",
          markers: false,
          scrub: true,
        },
      }
    );
  });
}

export {
  init
}
